import { useContext, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Button } from "../../../../components/atoms"
import { SelectGroup } from "../../../../components/molecules"
import { Pagination } from "../../../../components/organisms"
import { TablePassageiros } from "../../../../components/organisms/TablePassageiros"
import { AuthContext } from "../../../../contexts/Auth/AuthContext"
import { api } from "../../../../helpers"

export function Passageiros() {
  const {
    applicationData: { token, acesso, username }
  } = useContext(AuthContext)
  const [paginationControl, setPaginationControl] = useState<PaginationType>({
    offset: 0,
    limit: 5,
    count: 0
  })

  const { reservationID } = useParams()

  const [passageiros, setPassageiros] = useState([])

  useEffect(() => {
    ;(async () => {
      const {
        data: { TotalRegistros, Registros }
      } = await api.post("/api/reserva/passageiros", {
        codigoreserva: reservationID,
        limit: paginationControl.limit,
        offset: paginationControl.offset
      })

      const convertingDataToDisplay = (reservas: any) =>
        reservas.map((reserva: any) => {
          return {
            ...reserva
          }
        })

      setPaginationControl((current) => ({
        ...current,
        count: TotalRegistros
      }))

      const convertedDataForDisplay = convertingDataToDisplay(Registros)
      setPassageiros(convertedDataForDisplay)
    })()
  }, [
    acesso,
    paginationControl.limit,
    paginationControl.offset,
    token,
    username
  ])

  return (
    <div>
      <h1>Passageiros da Reserva</h1>
      <div className="row mt-1">
        <div className="col-sm-12 col-lg-3">
          <SelectGroup
            value={String(paginationControl.limit)}
            id="resultsPerPage"
            label="Resultados por página"
            options={[
              { text: "5", value: 5 },
              { text: "10", value: 10 },
              { text: "25", value: 25 },
              { text: "50", value: 50 }
            ]}
            onChange={(e) => {
              setPaginationControl({
                ...paginationControl,
                limit: Number(e.target.value !== "0" ? e.target.value : "5"),
                offset: 0
              })
            }}
          />
        </div>
        <div className="col-sm-12 col-lg-3"></div>
        <div className="col-sm-12 col-lg-3"></div>
        <div className="col-sm-12 col-lg-3">
          <Button
            onClick={() => {
              window.location.href = "/operacional/reservasefetuadas"
            }}
          >
            Voltar para reservas
          </Button>
        </div>

        <TablePassageiros data={passageiros}></TablePassageiros>

        <Pagination
          className="col-12"
          data={paginationControl}
          dispatch={setPaginationControl}
        />
      </div>
    </div>
  )
}
